import React, { Component } from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";

class EmptyBag extends Component {
  render() {
    const { myBagData, getMyBagSuccessfully } = this.props;

    return (
      <>
        {getMyBagSuccessfully && myBagData.cartItems && myBagData.cartItems.length === 0 ? (
          <div style={{ padding: "25px 0" }}>
            <Translation>
              {t => (
                <p style={{ margin: "0" }}>
                  {t(`checkout.yourShoppingBagSsEmpty`)}
                </p>
              )}
            </Translation>
          </div>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = state => ({
  getMyBagSuccessfully: state.myBag.getMyBagSuccessfully,
  myBagData: state.myBag.myBagData
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmptyBag);
